import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import { connect } from 'react-redux'

import { ListItem } from 'components/List'
import { City } from '../../../data/models/funnelOrder/cities'
import { AppState } from '../../../data/state'

interface ExcCitiesSummaryProps {
  excludedCities: string[]
  excludedCitiesIds: City[]
  loading: boolean
}

const ExcCitiesSummary: React.FC<ExcCitiesSummaryProps> = ({
  excludedCities,
  excludedCitiesIds,
  loading,
}) => {
  const loadingClass = loading ? 'is-loading' : ''
  return (
    <>
      {excludedCities.length !== 0 ? (
        <ListItem>
          <span className={loadingClass}>
            <DisplayContent
              contentKey="excluded-cities-summary"
              addNode={false}
            >
              Excluded cities:
            </DisplayContent>
            &nbsp;{excludedCities.join(', ')}
          </span>
        </ListItem>
      ) : null}
      {excludedCitiesIds.length > 0 ? (
        <ListItem>
          <span className={loadingClass}>
            <DisplayContent
              contentKey="excluded-cities-summary"
              addNode={false}
            >
              Excluded cities:
            </DisplayContent>
            &nbsp;{excludedCitiesIds.map(x => x.name).join(', ')}
          </span>
        </ListItem>
      ) : null}
    </>
  )
}

export default connect((state: AppState) => ({
  excludedCities: state.funnelOrder.excludedCities,
  excludedCitiesIds: state.funnelOrder.excludedCitiesIds,
  loading: state.contentEngine.loading,
}))(ExcCitiesSummary)
